import { SvgCut, TextButton } from '@loomhq/lens';
import React from 'react';

export const DISCARD_TRIM_BUTTON_CLASS = 'trim-bar-discard-trim-button';

const DiscardTrimButton = props => {
  const { selectedTrimRange, onDiscardTrimRange } = props;
  const canDiscardTrim = selectedTrimRange != null;
  const discardTrimOnClick = canDiscardTrim ? onDiscardTrimRange : null;

  return (
    <div className={DISCARD_TRIM_BUTTON_CLASS}>
      <TextButton
        icon={<SvgCut />}
        isDisabled={!canDiscardTrim}
        onClick={discardTrimOnClick}
      >
        Remove Trim
      </TextButton>
    </div>
  );
};

export default DiscardTrimButton;
